import { useNavigate } from "react-router-dom";

export default function RiskDisclaimer() {
  const navigate = useNavigate();

  return (
    <div className="flex-1 px-4 py-4">
      <div className="flex items-center gap-2 mb-4">
        <button onClick={() => navigate(-1)}
          className="w-8 h-8 rounded-full bg-background-100 flex items-center justify-center cursor-pointer shrink-0">
          <i className="ri-arrow-left-s-line text-foreground-600 text-sm" />
        </button>
        <h1 className="text-base font-bold text-foreground-950">风险提示与免责声明</h1>
      </div>

      <div className="bg-white rounded-xl p-4 border border-background-200/60 space-y-5 text-xs text-foreground-600 leading-relaxed">
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-3">
          <p className="text-[11px] text-amber-800 font-medium">⚠️ 重要提示：本平台为学习与模拟演示工具，不构成投资建议。请在使用前仔细阅读以下全部内容。</p>
        </div>

        <section>
          <h2 className="text-sm font-bold text-foreground-950 mb-2">第一条 模拟交易性质</h2>
          <div className="space-y-1.5">
            <p>1.1 本平台所有交易均为 AI 智能体在虚拟资金账户中的策略推演演示。所有"买入/卖出/加仓/减仓/持仓"等操作均为模拟情景推演，不涉及任何真实的证券账户、资金账户或实盘交易。</p>
            <p>1.2 任何在平台上显示的收益、亏损、收益率、夏普比率等数据均为基于虚拟资金的模拟结果，不代表任何实际投资业绩。</p>
            <p>1.3 模拟交易与实盘交易存在本质差异，模拟环境无法完全复现真实市场的所有因素。</p>
          </div>
        </section>

        <section>
          <h2 className="text-sm font-bold text-foreground-950 mb-2">第二条 不构成投资建议</h2>
          <div className="space-y-1.5">
            <p>2.1 本平台生成的任何信息，包括但不限于 AI 研究报告、策略信号、买卖建议、市场分析、技术指标解读、财务数据分析等，均不构成任何形式的投资建议、投资邀约、投资承诺或证券咨询。</p>
            <p>2.2 本平台不是中国证监会备案的证券投资咨询机构，不提供任何形式的证券投资顾问服务。</p>
            <p>2.3 AI 的分析和判断仅基于算法模型和历史数据，不应作为您做出任何投资决策的唯一依据。</p>
          </div>
        </section>

        <section>
          <h2 className="text-sm font-bold text-foreground-950 mb-2">第三条 模拟与实盘的差异</h2>
          <div className="space-y-1.5">
            <p>3.1 流动性差异：模拟交易不考虑实际交易中的流动性冲击，模拟盘可以以任何价格成交任意数量，而实盘中大额订单可能影响市场价格。</p>
            <p>3.2 交易延迟：模拟交易不考虑真实市场中的交易延迟、网络延迟、滑点等因素，所有模拟成交均即时完成。</p>
            <p>3.3 交易成本：模拟交易通常不考虑或简化处理佣金、印花税、过户费等交易成本，而实盘交易中这些成本会显著影响实际收益。</p>
            <p>3.4 市场影响：模拟交易者的决策不会影响市场价格，而实盘交易者的买卖行为本身可能影响短期价格走势。</p>
            <p>3.5 心理因素：模拟交易不涉及真实资金，用户和 AI 均不受恐惧、贪婪等情绪影响，而实盘交易中这些心理因素对决策有重大影响。</p>
            <p>3.6 因此，模拟交易结果不代表未来实际投资表现，模拟收益不等于实际可实现的收益。</p>
          </div>
        </section>

        <section>
          <h2 className="text-sm font-bold text-foreground-950 mb-2">第四条 信息准确性与完整性</h2>
          <div className="space-y-1.5">
            <p>4.1 本平台尽力确保数据的准确性，但不对数据来源的完整性和及时性做出任何保证。</p>
            <p>4.2 市场数据：行情数据可能因数据源问题存在延迟（通常为 15 分钟到 1 天）。盘口数据为模拟生成，不反映真实市场深度。</p>
            <p>4.3 财务数据：上市公司的财务数据可能存在季度滞后，AI 使用的数据可能不是最新披露的财务信息。</p>
            <p>4.4 新闻资讯：AI 分析的新闻内容可能来自自动抓取，存在时效性滞后或内容解读偏差。</p>
          </div>
        </section>

        <section>
          <h2 className="text-sm font-bold text-foreground-950 mb-2">第五条 AI 局限性</h2>
          <div className="space-y-1.5">
            <p>5.1 数据时效性：AI 模型的训练数据和知识截止日期存在限制，可能无法反映最新的市场变化、政策变更或突发事件。</p>
            <p>5.2 历史依赖：AI 分析和预测基于历史数据，而金融市场具有高度不确定性，历史规律不能预测未来走势。</p>
            <p>5.3 数据偏差：算法可能受到训练数据的偏差影响，对于特定类型的事件或极端市场情况可能产生不准确的判断。</p>
            <p>5.4 黑箱特性：部分 AI 模型的决策过程存在"黑箱"问题，即使输出了分析结果，其推理过程可能难以完全解释。</p>
            <p>5.5 缺乏常识：AI 缺乏对真实世界政治、经济、社会事件的理解能力和常识判断能力，可能在不熟悉的场景下做出不合理判断。</p>
          </div>
        </section>

        <section>
          <h2 className="text-sm font-bold text-foreground-950 mb-2">第六条 风险自担</h2>
          <div className="space-y-1.5">
            <p>6.1 用户理解并同意，任何基于本平台信息做出的投资决策均由用户自行承担全部风险。</p>
            <p>6.2 本平台不对因使用或依赖本平台内容而产生的任何直接或间接损失（包括但不限于投资损失、机会成本）承担责任。</p>
            <p>6.3 用户应独立判断并核实本平台提供的信息，必要时咨询持牌的专业投资顾问。</p>
          </div>
        </section>

        <section>
          <h2 className="text-sm font-bold text-foreground-950 mb-2">第七条 特别声明</h2>
          <div className="space-y-1.5">
            <p>7.1 本平台不提供任何形式的证券投资顾问服务，不承诺任何投资收益。</p>
            <p>7.2 本平台不具备中华人民共和国证券投资咨询业务资质。任何在本平台产生的投资建议类信息均不构成法律意义上的投资建议。</p>
            <p>7.3 本平台鼓励用户通过正规渠道学习投资知识，提高自身的投资分析能力。</p>
          </div>
        </section>

        <p className="text-[10px] text-foreground-400 pt-2 border-t border-background-100">版本：V1.0 &#8226; 最后更新：2026年7月</p>
      </div>
    </div>
  );
}
